import { ServiceState } from '@ekkogmbh/apisdk';
import { Box, Stack, Typography } from '@mui/material';
import React from 'react';

const COLOR_MAP: Record<ServiceState, string> = {
  [ServiceState.UNKNOWN]: 'text.disabled',
  [ServiceState.OFFLINE]: 'error.main',
  [ServiceState.ONLINE]: 'success.main',
};

interface Props {
  label?: string;
  state?: ServiceState;
  loading?: boolean;
}

/** A small colored dot (green/red/grey) for service state, with optional label. */
export const StatusDot = ({ label, state = ServiceState.UNKNOWN, loading = false }: Props): React.JSX.Element => {
  const color = loading ? COLOR_MAP[ServiceState.UNKNOWN] : COLOR_MAP[state];

  return (
    <Stack direction={'row'} alignItems={'center'} spacing={0.75}>
      <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: color, flexShrink: 0 }} />
      {label && (
        <Typography variant={'caption'} sx={{ color, fontWeight: 600, pt: 0.5 }}>
          {label}
        </Typography>
      )}
    </Stack>
  );
};
